import React,  { useState } from 'react'
import style from './App.module.sass'
import Header from './Components/Header'
import QuizOne from './Components/QuizOne';
import StoryOne from './Components/StoryOne';
import QuizTwo from './Components/QuizTwo';
import StoryTwo from './Components/StoryTwo';
import { ThemeProvider } from 'styled-components';
import { neon, pink, GlobalStyles} from './styles/themes'
import InteractOne from './Components/InteractOne';
import InteractTwo from './Components/InteractTwo';
import InteractThree from './Components/InteractThree';
import Comment from './Components/Comment';
import paperFlipSoundFile from './media/paperFlip.wav';
import correctSoundFile from './media/correct.mp3';
import switchSoundFile from './media/incorrectSound.wav';
import dingSoundFile from './media/dingSound.wav';
import clockSoundFile from './media/clockTickTrimmed.wav';


const App = () => {
  const [theme, setTheme] = useState(neon)
  const paperFlipSound = React.createRef()
  const correctSound = React.createRef()
  const switchSound = React.createRef()
  const dingSound = React.createRef()
  const clockSound = React.createRef()

  const [soundEnabled, setSoundEnabled] = useState (true)

  const playSoundEffects = (e) => {
    if (soundEnabled) {
      e.current.volume = 0.4;
      e.current.play()
    }
  }

  const playClock = () => {
    if (soundEnabled) {
      clockSound.current.play()
      clockSound.current.loop = true
    }
  }
  const pauseClock = () => {
      clockSound.current.pause()
  }

  return (
    <div className = {`${style.container} main`}>
      {/* Assets */}
       <audio src = {paperFlipSoundFile}  className = "audioFile" ref = {paperFlipSound} > </audio>
       <audio src = {correctSoundFile}  className = "audioFile" ref = {correctSound} > </audio>
       <audio src = {switchSoundFile}  className = "audioFile" ref = {switchSound} > </audio>
       <audio src = {dingSoundFile}  className = "audioFile" ref = {dingSound} > </audio>
       <audio src = {clockSoundFile}  id = "clockSoundID" className = "audioFile" ref = {clockSound} > </audio>
      <ThemeProvider theme={theme}>
        <GlobalStyles />
          <div className={`${style.grid} mainOne`}>
            <Header  
            setTheme={setTheme} 
            theme={theme} 
            setSoundEnabled={setSoundEnabled} 
            soundEnabled={soundEnabled}  
            playSwitch = {() => playSoundEffects(switchSound)} 
            />
            <QuizOne
              playPaperFlip = {() => playSoundEffects(paperFlipSound)} 
              playCorrect = {() => playSoundEffects(correctSound)} 
              playSwitch = {() => playSoundEffects(switchSound)} 
            />
            <StoryTwo playCorrect = {() => playSoundEffects(correctSound)} />
            <InteractOne theme={theme}/>
            <QuizTwo 
              playPaperFlip = {() => playSoundEffects(paperFlipSound)} 
              playCorrect = {() => playSoundEffects(correctSound)} 
              playSwitch = {() => playSoundEffects(switchSound)} 
            />
            <InteractTwo
            playDing = {() => playSoundEffects(dingSound)} 
            />
            <InteractThree
             theme={theme}
             playClock = {() => playClock()} 
             pauseClock = {() => pauseClock()} 
             />
            <StoryOne playPaperFlip = {() => playSoundEffects(paperFlipSound)} />
            <Comment/>
        </div>
      </ThemeProvider>
    </div>
  );
}

export default App;

